'use client';

import { Button } from '@common/components';
import { SvgShare2 } from '@common/icon';
import { useState } from 'react';

import { CustomLink } from '@/app/_components/CustomLink';

import { SnsShareDrawer } from './SnsShareDrawer';

const GOOGLE_FORM_URL = 'https://forms.gle/mGg3xYe1KGuUXyZJ9';

export const SnsShareButton = () => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="flex w-full items-center gap-16">
      <Button className="flex-1" dimensions="H56" asChild>
        <CustomLink
          href={GOOGLE_FORM_URL}
          target="_blank"
          className="flex items-center gap-8"
        >
          구글 폼 입력하기
        </CustomLink>
      </Button>
      <button
        type="button"
        className="flex-center"
        onClick={() => setIsOpen(true)}
        aria-label="공유하기"
      >
        <SvgShare2 />
      </button>
      <SnsShareDrawer opened={isOpen} onClose={() => setIsOpen(false)} />
    </div>
  );
};
